export default "__VITE_ASSET__dCoR8o$m__"